import { useCallback } from 'react';

import { reducePlaceholdersToFormattedTextBlocks } from './locale-smart-block-content-helpers';
import { TransformSmartBlockContentFn } from './types';
import { usePlaceholderFormatters } from './use-placeholder-formatters';

export const useLocaleSmartBlockContent = () => {
  const { formatPlaceholderInterpolation } = usePlaceholderFormatters();

  const transformSmartBlockContent = useCallback<TransformSmartBlockContentFn>(
    ({ blockContent, interpolationSourceObject, placeholderFieldsMap }) => ({
      ...blockContent,
      localeRaw: reducePlaceholdersToFormattedTextBlocks({
        blocks: blockContent?.localeRaw ?? [],
        interpolationSourceObject,
        placeholderFieldsMap,
        formatPlaceholderInterpolation,
      }),
    }),
    [formatPlaceholderInterpolation]
  );

  return {
    transformSmartBlockContent,
  };
};
